import { sandhillsRequest, insertURLParameter } from '@Components/Utilities/SandhillsUtility';
import { cookieNames, consentCookieNames, sandhillsCookieClassifications } from '@Components/Utilities/SandhillsConstants';


const cookieBotActive = () => (typeof Cookiebot != 'undefined' && typeof Cookiebot.consent != 'undefined');
const cookieBotClassificationAllowed = (sandhillsClassification) => {
    return (sandhillsClassification == sandhillsCookieClassifications.Advertising && Cookiebot.consent.marketing) ||
        (sandhillsClassification == sandhillsCookieClassifications.Analytics && Cookiebot.consent.statistics) ||
        (sandhillsClassification == sandhillsCookieClassifications.Customization && Cookiebot.consent.preferences) ||
        (sandhillsClassification == sandhillsCookieClassifications.StrictlyNecessary);
}

const cookieYesActive = () => window.getCkyConsent;
const cookieYesClassificationAllowed = (sandhillsClassification) => {
    const cookieYesConsent = getCkyConsent();

    return (sandhillsClassification == sandhillsCookieClassifications.Advertising && cookieYesConsent.categories.advertisement) ||
        (sandhillsClassification == sandhillsCookieClassifications.Analytics && cookieYesConsent.categories.analytics && cookieYesConsent.categories.performance) ||
        (sandhillsClassification == sandhillsCookieClassifications.Customization && cookieYesConsent.categories.functional) ||
        (sandhillsClassification == sandhillsCookieClassifications.StrictlyNecessary);
}

const osanoActive = () => (typeof Osano != 'undefined' && typeof Osano.cm != 'undefined');
const osanoClassificationAllowed = (sandhillsClassification) => {
    return (sandhillsClassification == sandhillsCookieClassifications.Advertising && Osano.cm.marketing) ||
        (sandhillsClassification == sandhillsCookieClassifications.Analytics && Osano.cm.analytics) ||
        (sandhillsClassification == sandhillsCookieClassifications.Customization && Osano.cm.personalization) ||
        (sandhillsClassification == sandhillsCookieClassifications.StrictlyNecessary);
}

const usercentricsActive = () => (typeof UC_UI !== 'undefined');
const usercentricsClassificationAllowed = (sandhillsClassification) => {
    var consent = true;
    if (sandhillsClassification != sandhillsCookieClassifications.StrictlyNecessary) {
        consent = false;
        var consentCookie = getCookie(consentCookieNames.UserCentrics);
        if (consentCookie) {
            const parsedConsent = JSON.parse(decodeURIComponent(consentCookie));
            consent = (sandhillsClassification == sandhillsCookieClassifications.Advertising && parsedConsent.Advertising) ||
                (sandhillsClassification == sandhillsCookieClassifications.Analytics && parsedConsent.Analytics) ||
                (sandhillsClassification == sandhillsCookieClassifications.Customization && parsedConsent.Customization);
        }
    }

    // Return true since Usercentrics is not loaded
    return consent;
};

const SandhillsConsentClassificationAllowed = (sandhillsClassification) => {
    var RequireOptInConsent = sandhills.TradeSites.React.ComponentProps['requireOptInConsent'];
    var consent = true;

    if (RequireOptInConsent && sandhillsClassification != sandhillsCookieClassifications.StrictlyNecessary) {
        consent = false;
        var consentCookie = sandhillsCookiesConsent();
        if (consentCookie) {
            consent = (sandhillsClassification == sandhillsCookieClassifications.Advertising && consentCookie.Advertising) ||
                (sandhillsClassification == sandhillsCookieClassifications.Analytics && consentCookie.Analytics) ||
                (sandhillsClassification == sandhillsCookieClassifications.Customization && consentCookie.Customization)
        }
    }

    return consent;
}

function getAllSavedCookieNames() {
    var allCookies = document.cookie.split('; ');
    var cookieNames = [];

    for (var i = 0; i < allCookies.length; i++) {
        var cookie = allCookies[i];
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        cookieNames.push(name);
    }

    return cookieNames;
}

const getCookie = (name) => {
    let value = '; ' + document.cookie;
    let parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts.pop().split(';').shift();
    return null;
};

const getExpireTimeUTCStringForCookies = (numOfDaysTilExpired) => {
    let now = new Date();
    let time = now.getTime();
    let daystoSeconds = 1000 * 86400 * numOfDaysTilExpired;
    let expireTime = time + daystoSeconds;
    now.setTime(expireTime);
    return now.toUTCString();
};

const sandhillsCookiesConsent = () => {
    var cookie = getCookie(consentCookieNames.SandhillsConsent);
    let output;
    try {
        output = cookie ? JSON.parse(cookie) : cookie;
    } catch (e) {
        try {
            output = cookie ? JSON.parse(decodeURIComponent(cookie)) : cookie;
        } catch (err) {
            output = cookie;
        }
    }
    return output;
}

//Get expiration from specific date time
const getExpirationUTCFromDateTime = (dateTime, numOfDaysTilExpired) => {
    var date = new Date(dateTime);
    var time = date.getTime();
    let daysToSeconds = 1000 * 86400 * numOfDaysTilExpired;
    let expireTime = time + daysToSeconds;
    date.setTime(expireTime);

    return date.toUTCString();
}

// The server-side can't expire cookies for hosted sites (due to response being from a different domain), so we need to check client-side before allowing cookie
const isCookieAllowed = (cookieName) => {
    try {
        var cookieClassificationMappings = sandhills.TradeSites.React.ComponentProps['sandhillsCookieClassifications'];

        if (cookieClassificationMappings) {
            // Use match method because some cookie names in the dictionary are using regex
            var sandhillsClassification = cookieClassificationMappings.find(x => x.Name === cookieName)?.Classification;

            if (!sandhillsClassification) {
                var regexFiltered = cookieClassificationMappings.filter(m => m.IsRegexPattern);
                if (regexFiltered && regexFiltered.length > 0) {
                    var match = regexFiltered.filter(c => cookieName.match(c.Name.toString(), 'i'));
                    if (match && match.length > 0) {
                        sandhillsClassification = match[0].Classification;
                    }
                };
            }

            if (sandhillsClassification) {
                if (cookieBotActive()) {
                    return cookieBotClassificationAllowed(sandhillsClassification);
                } else if (cookieYesActive()) {
                    return cookieYesClassificationAllowed(sandhillsClassification);
                } else if (osanoActive()) {
                    return osanoClassificationAllowed(sandhillsClassification);
                } else if (usercentricsActive()) {
                    return usercentricsClassificationAllowed(sandhillsClassification);
                } else {
                    return SandhillsConsentClassificationAllowed(sandhillsClassification);
                }
            }
        }
    } catch (error) {
        console.error(error);
    }

    // Allow cookies for now if not in mappings since this method is used to check all saved cookies when consent changes
    // and a lot of the non-mapped cookies will be handled independently by the cookie consent provider scripts
    return true;
}

const setCompareCookie = (name, ids, mediaIds) => {
    setCookie(name, 'IDs=' + ids + '&MediaIds=' + mediaIds);
};

const setCookie = (name, value, expiresOn, domain) => {
    if (isCookieAllowed(name)) {
        document.cookie = name + '=' + value + ';' + 'Secure;' + (expiresOn ? ('expires=' + expiresOn + ';') : '') + ' path=/' + (domain ? (';domain=' + domain) : '');
    }
};

const setBetaSiteCookie = (value) => {
    if (isCookieAllowed(cookieNames.useBetaSiteCookie)) {
        document.cookie = cookieNames.useBetaSiteCookie + '=' + value + ';' + 'Secure;session=true;path=/';
    }
};

const setDrillDownCookie = (ind, cat, make, model, dismantledMake, dismantledModel, tab, fitsto, artype, lt, isMG) => {
    document.cookie = setCookie('DDSearch', 'ddIndustry=' + ind + '&ddCategory=' + cat + '&ddManu=' + encodeURIComponent(make) + '&ddModel=' + encodeURIComponent(model) + '&ddDismantledMake=' + encodeURIComponent(dismantledMake) + '&ddDismantledModel=' + encodeURIComponent(dismantledModel) + '&tab=' + tab + '&fitsto=' + fitsto + '&artype=' + artype + '&ddLT=' + lt + '&ddMG=' + isMG + '; path=/');
}

const setLocalStorageValue = (name, value) => {
    if (isCookieAllowed(name)) {
        localStorage.setItem(name, value);
    }
};

const setSessionValue = (name, value) => {
    if (isCookieAllowed(name)) {
        window.sessionStorage.setItem(name, value);
    }
};

const clearCookie = (name) => {
    document.cookie = name + '=' + '' + '; path=/';
};

// Compare Cookie
const tryAddListingToCompareCookie = (listingID, mediaId) => {
    let cookie = getCookie(cookieNames.compare);
    if (!cookie) {
        setCompareCookie(cookieNames.compare, [listingID], [mediaId]);
        return true;
    } else {
        let cookieParts = cookie.split('&');
        let idList = cookieParts[0].replace("IDs=", "").split(',');
        let mediaIdlist = cookieParts[1].replace("MediaIds=", "").split(',');
        if (idList.indexOf(listingID.toString()) === -1 && idList.length < 4) {
            idList.push(listingID);
            mediaIdlist.push(mediaId);
            setCompareCookie(cookieNames.compare, idList, mediaIdlist);
            return true;
        } else {
            return false;
        }
    }
};

const tryDeleteCompareListingFromCookie = (listingID) => {
    let cookie = getCookie(cookieNames.compare);
    if (cookie) {
        let cookieParts = cookie.split('&');
        let idList = cookieParts[0].replace("IDs=", "").split(',');
        let mediaIdlist = cookieParts[1].replace("MediaIds=", "").split(',');
        let index = idList.indexOf(listingID.toString());
        if (index !== -1) {
            idList.splice(index, 1);
            mediaIdlist.splice(index, 1);
            if (idList.length > 0) {
                setCompareCookie(cookieNames.compare, idList, mediaIdlist);
            } else {
                clearCookie(cookieNames.compare);
            }
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

// UserSettings Cookie
const saveUserSettingsCookie = ({
    width = null,
    height = null,
    unit = null,
    currency = null,
    languageCode = null,
    timeZone = null,
    countryCode = null,
    url = ''
} = {}) => {
    let builtURL = url;
    let params = {};

    if (builtURL?.indexOf('?') > -1) {
        let hsQS = builtURL.split('?')[1];
        let queryParams = new URLSearchParams(hsQS);
        for (let [key, value] of queryParams.entries()) {
            params[key] = value;
        }
        //remove the query string from the built URL
        builtURL = builtURL.split('?')[0];
    } 
    
    if (width && height) {
        builtURL = insertURLParameter(builtURL, 'width', width);
        builtURL = insertURLParameter(builtURL, 'height', height);
    }

    if (unit) {
        builtURL = insertURLParameter(builtURL, 'unit', unit);
    }

    if (currency) {
        builtURL = insertURLParameter(builtURL, 'currency', currency);
    }

    if (languageCode) {
        builtURL = insertURLParameter(builtURL, 'languageCode', languageCode);
    }

    if (countryCode) {
        builtURL = insertURLParameter(builtURL, 'sCountryCode', countryCode);
    }

    if (timeZone) {
        builtURL = insertURLParameter(builtURL, 'timeZone', timeZone);
    }

    builtURL = insertURLParameter(builtURL, 'clientSideReferrer', encodeURIComponent(window.location.href));

    if (params) {
        Object.keys(params).forEach((key) => {
            if (params[key]) {
                builtURL = insertURLParameter(builtURL, key, params[key]);
            }
        });
    }; 

    return sandhillsRequest({
        url: builtURL,
        errorHandling: {
            useConsole: false,
            useAlert: false
        }
    }).then((data) => {
        if (window.Overrides.isHostedSite) {
            setCookie(cookieNames.userSettings, data.cookieValue, getExpireTimeUTCStringForCookies(365));
        }
        return data;
    });
};

const getSearchHistoryValues = () => {
    let cookie = getCookie(cookieNames.keywordSearchHistory);
    if (!cookie) {
        return null;
    }
    else {
        let splitValues = cookie.split(',');
        return splitValues.map((option) => { let splitOption = option.split('&='); return { Label: splitOption[0], value: splitOption[0], Url: splitOption[1] } });
    }
};

const removeLocalStorageValue = (name) => {
    localStorage.removeItem(name);
};

const removeUnapprovedCookies = () => {
    let allCookieNames = getAllSavedCookieNames();

    allCookieNames.forEach(cookieName => {
        var allowedCookie = isCookieAllowed(cookieName);
        if (!allowedCookie) {
            const rootDomain = getRootDomain();
            const domains = ['', rootDomain, `.${rootDomain}`];
            const expiry = 'Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            domains.forEach(domain => {
                const domainPart = domain ? `domain=${domain};` : '';
                document.cookie = `${cookieName}=; ${expiry} path=/; ${domainPart}`;
            });
        }
    });
};

const removeUnapprovedLocalStorage = () => {
    let allLocalStorageKeys = Object.keys(localStorage);

    allLocalStorageKeys.forEach(key => {
        if (!isCookieAllowed(key)) {
            localStorage.removeItem(key);
        }
    });
};

const removeUnapprovedSessionStorage = () => {
    let allSessionStorageKeys = Object.keys(sessionStorage);

    allSessionStorageKeys.forEach(key => {
        if (!isCookieAllowed(key)) {
            sessionStorage.removeItem(key);
        }
    });
};

const setSearchHistoryCookie = (value, url) => {
    if (value && url) {
        let expiresOn = new Date();
        expiresOn.setDate(expiresOn.getDate() + 30);
        let cookie = getCookie(cookieNames.keywordSearchHistory);
        let concatValue = value + '&=' + url;
        if (!cookie) {
            setCookie(cookieNames.keywordSearchHistory, concatValue, expiresOn.toUTCString());
        }
        else {
            let splitValues = cookie.split(',');
            if (splitValues.includes(concatValue)) {
                return;
            }

            if (splitValues.length > 3) {
                let newCookie = splitValues[1] + ',' + splitValues[2] + ',' + splitValues[3] + ',' + concatValue;
                setCookie(cookieNames.keywordSearchHistory, newCookie, expiresOn.toUTCString());
            }
            else {
                let newCookie = cookie += ',' + concatValue;
                setCookie(cookieNames.keywordSearchHistory, newCookie, expiresOn.toUTCString());
            }
        }
    }
};

const setConsentChanged = (sandhillsConsent) => {
    try {
        let cookieBotEnabled = cookieBotActive();
        let cookieYesEnabled = cookieYesActive();
        let osanoEnabled = osanoActive();
        let usercentricsEnabled = usercentricsActive() || sandhills.TradeSites.React.ComponentProps['useUserCentricsCMP'];

        if (cookieBotEnabled || cookieYesEnabled || osanoEnabled || usercentricsEnabled || sandhillsConsent) {
            let removeUnapprovedValues = () => {
                removeUnapprovedCookies();
                removeUnapprovedLocalStorage();
                removeUnapprovedSessionStorage();
            };

            if (usercentricsEnabled) {
                let initialConsentCaptured = false;
                const captureInitialConsent = () => {
                    if (initialConsentCaptured) return;
                    if (getCookie(consentCookieNames.UserCentrics)) {
                        initialConsentCaptured = true;
                        return;
                    }

                    window.__ucCmp?.getConsentDetails().then(consentDetails => {
                        if (initialConsentCaptured) return;
                        setUserCentricsConsentCookie(consentDetails, 365);
                        expireSandhillsConsentCookie();
                        initialConsentCaptured = true;
                    }).catch(e => { console.error('Unable to retrieve initial consent details'); });
                }

                if (typeof window.__ucCmp?.getConsentDetails === 'function') {
                    captureInitialConsent();
                } else {
                    window.addEventListener('UC_UI_INITIALIZED', captureInitialConsent, { once: true });
                }

                window.addEventListener('UC_CONSENT', function (e) {
                    setUserCentricsConsentCookie(e.detail, 365);
                    removeUnapprovedValues();
                    initialConsentCaptured = true;
                }, false);
            } else if (cookieBotEnabled) {
                window.addEventListener('CookiebotOnAccept', function (e) {
                    removeUnapprovedValues();
                }, false);

                window.addEventListener('CookiebotOnDecline', function (e) {
                    removeUnapprovedValues();
                }, false);
            } else if (cookieYesEnabled) {
                document.addEventListener("cookieyes_consent_update", function (eventData) {
                    removeUnapprovedValues();
                });
            } else if (osanoEnabled) {
                Osano.cm.addEventListener('osano-cm-consent-saved', (newConsent) => {
                    // This cookie is set by us and not Osano (we're setting the unencrypted version)
                    // Therefore, we need to make sure it's updated when the consent changes
                    setCookie(consentCookieNames.OsanoUnencrypted, JSON.stringify(newConsent), getExpireTimeUTCStringForCookies(365));
                    removeUnapprovedValues();
                });
            } else if (sandhillsConsent) {
                var RequireOptInConsent = sandhills.TradeSites.React.ComponentProps['requireOptInConsent'];
                if (RequireOptInConsent) {
                    removeUnapprovedValues();
                    setConsentModeSettings(sandhillsConsent);
                }
            }
        }
    } catch (error) {
        console.error(error);
    }
}

const getConsentCookie = (useGuestCookieName) => {
    var consent = null;
    var json = getConsentCookieJSON(useGuestCookieName);

    try {
        if (json) {
            consent = JSON.parse(json);
        }
    } catch {
        consent = null;
    }
    return consent;
}

const getConsentCookieJSON = () => {
    var value = getCookie(getConsentCookieName())
    if (value && value != '') {
        try {
            return decodeURIComponent(value);
        } catch (err) {
            console.log(err);
        }
    }
    return null;
}

const getConsentCookieName = () => {
    return consentCookieNames.SandhillsConsent;
}


const SetSandhillsConsentCookie = (sandhillsConsent, daysToExpire, centralUserTrackingID) => {
    var cookieName = consentCookieNames.SandhillsConsent;
   
    if (centralUserTrackingID && parseInt(centralUserTrackingID) > 0) {
        cookieName += '-' + centralUserTrackingID;
    } 

    try {
        var content = encodeURIComponent(JSON.stringify(sandhillsConsent))
        var rootDomain = getRootDomain();
        setCookie(cookieName, content, getExpirationUTCFromDateTime(sandhillsConsent.ActionDateTime, daysToExpire), rootDomain);
    } catch (err) {
        console.log(err);
    }
}

const setUserCentricsConsentCookie = (detail, daysToExpire) => {
    if (!detail?.categories) return;

    try {
        const categoryAllowed = (category) => category?.state === 'ALL_ACCEPTED'; 
        const personalizationCategory = Object.values(detail.categories).find((category) => category?.name === 'Personalized Cookies');

        const cookieName = consentCookieNames.UserCentrics;

        const currentConsent = getCookie(cookieName);
        let consentStatus;

        if (detail.consent) {
            const previousStatus = currentConsent?.ConsentStatus;
            if (detail.consent.type === "EXPLICIT") {
                if (previousStatus === "ACCEPT" || previousStatus === "UPDATE") {
                    consentStatus = "UPDATE";
                } else {
                    consentStatus = "ACCEPT";
                }
            } else {
                consentStatus = "DENY";
            }
        } else {
            consentStatus = currentConsent?.ConsentStatus || null;
        }

        var ucConsent = {
            StrictlyNecessary: true,
            Analytics: categoryAllowed(detail.categories.functional),
            Advertising: categoryAllowed(detail.categories.marketing),
            Customization: categoryAllowed(personalizationCategory),
            ActionDateTime: new Date().toISOString(),
            ConsentStatus: consentStatus,
        };

        var content = encodeURIComponent(JSON.stringify(ucConsent));
        var rootDomain = getRootDomain();
        setCookie(cookieName, content, getExpirationUTCFromDateTime(ucConsent.ActionDateTime, daysToExpire ?? 365), rootDomain);
    } catch (err) {
        console.error(err);
    }
}

const expireSandhillsConsentCookie = () => {
    const oldConsent = getConsentCookie(true);
    if (oldConsent) {
        // expire the logged in cookie
        SetSandhillsConsentCookie(oldConsent, -1, sandhills.TradeSites.React.ComponentProps['userAuthenticatedTrackingID']);
        // expire the guest cookie
        SetSandhillsConsentCookie(oldConsent, -1, null);
    }
}

const getRootDomain = () => {
    const slDs = [
        'co', 'com', 'qc' 
    ];

    const parts = window.location.hostname.split('.');
    const len = parts.length;

    if (len <= 2) {
        return window.location.hostname;
    }

    // 2. Check for a three-part root domain (e.g., 'trucklocator.co.uk')
    // We check if the part before the TLD (parts[len - 2]) is a known SLD.
    const secondLast = parts[len - 2];
    const isSLD = slDs.includes(secondLast);

    if (isSLD) {
        // If it's a known SLD (e.g., 'co' in '.co.uk'), we need the last 3 parts.
        return parts.slice(len - 3).join('.');
    } else {
        // Otherwise, it's a standard two-part TLD (e.g., '.com', '.dev', '.app').
        return parts.slice(len - 2).join('.');
    }
}

const setConsentModeSettings = (sandhillsConsent) => {
    try {
        if (sandhillsConsent) {
            const consent =  {
                advertisingConsent: getAnalyticsConsentValue(sandhillsConsent.Advertising),
                analyticsConsent: getAnalyticsConsentValue(sandhillsConsent.Analytics),
                personalizationConsent: getAnalyticsConsentValue(sandhillsConsent.Customization),
                securityConsent: getAnalyticsConsentValue(sandhillsConsent.StrictlyNecessary),
            }

            if (typeof consentListeners !== 'undefined' && consentListeners.length > 0) {
                consentListeners.forEach((callback) => {
                    callback(consent);
                });
            }
        }
    } catch (e) {
        console.error(e);
    }
}

const getAnalyticsConsentValue = (consent) => {
    return (typeof consent == 'boolean' && consent == true) ? "granted" : "denied";
}

const setConsentCookie = () => {
    try {
        if (typeof Osano != 'undefined' && typeof Osano.cm != 'undefined' && getCookie(consentCookieNames.OsanoUnencrypted) == null) {
            // Osano consent cookie is encrypted so creating unencrypted version for server-side
            setCookie(consentCookieNames.OsanoUnencrypted, JSON.stringify(Osano.cm.getConsent()), getExpireTimeUTCStringForCookies(365));                  
        }
    } catch (error) {
        console.error(error);
    }
}


const hasCurrentUserLocationCookie = () => {
    return getCookie(cookieNames.CurrentUserLocationCookie);
}

const hasSCFCookie = () => {
    return getCookie(cookieNames.SCFCookie);
}

const showUserCentricsBanner = (layer) => {
    const useUserCentricsCMP = sandhills.TradeSites.React.ComponentProps['useUserCentricsCMP'];
    if (useUserCentricsCMP) {
        if (typeof window.UC_UI === 'undefined') {
            window.addEventListener('UC_UI_INITIALIZED', function () {
                showUserCentricsBanner(layer);
            }, { once: true });
            return;
        }
        if (!layer || layer === 1) {
            // standard consent banner
            window.UC_UI.showFirstLayer();
        } else if (layer === 2) {
            // detailed consent banner
            window.UC_UI.showSecondLayer();
        }
    }    
}

export {
    getCookie,
    getConsentCookie,
    getConsentCookieJSON,
    getConsentCookieName,
    getExpireTimeUTCStringForCookies,
    setCookie,
    clearCookie,
    setCompareCookie,
    tryAddListingToCompareCookie,
    tryDeleteCompareListingFromCookie,
    saveUserSettingsCookie,
    SetSandhillsConsentCookie,
    setSearchHistoryCookie,
    getAllSavedCookieNames,
    getSearchHistoryValues,
    removeLocalStorageValue,
    setConsentModeSettings,
    setConsentChanged,
    setConsentCookie,
    setDrillDownCookie,
    setLocalStorageValue,
    setSessionValue,
    setBetaSiteCookie,
    showUserCentricsBanner,
    hasCurrentUserLocationCookie,
    hasSCFCookie,
    getRootDomain
};